import React from 'react'
import { InputLabel } from '../styled/styled'
import { InfoIcon } from '@fareye/ui'
import { useTranslation } from '@fareye/common'
interface ICustomLabel {
  style?: React.CSSProperties
  label: string
  desc?: string
}
export function CustomLabel({ style, label, desc }: ICustomLabel) {
  const { t } = useTranslation()
  return (
    <div style={{ marginBottom: '4px' }}>
      <InputLabel variant="h6" style={style}>
        {t(label)}
      </InputLabel>
      {desc && (
        <InfoIcon
          style={{ marginLeft: 5, marginRight: 5, cursor: 'pointer' }}
          title={t(desc)}
        />
      )}
    </div>
  )
}
